var React = require('react');

function CPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_17","data-name":"Path 17","d":"M4409.643,1250.957h0a14.924,14.924,0,0,0-15,14.848c0,9.962,9.553,21.18,13.412,25.3a2.17,2.17,0,0,0,3.176,0c3.859-4.125,13.412-15.344,13.412-25.3a14.925,14.925,0,0,0-15-14.848m1.07,22.445c-4.25,0-7.787-2.556-7.787-7.758s3.537-7.757,7.787-7.757a6.957,6.957,0,0,1,5.29,2.17l-2.288,2.407a4.453,4.453,0,0,0-2.943-1.158,4.121,4.121,0,0,0-4.22,4.338,3.992,3.992,0,0,0,4.161,4.28,4.4,4.4,0,0,0,3.21-1.218l2.437,2.378a7.539,7.539,0,0,1-5.647,2.318","transform":"translate(-4394.643 -1250.957)","fill":"#dca947"}));
}

CPin.defaultProps = {"width":"30","height":"40.843","viewBox":"0 0 30 40.843"};

module.exports = CPin;

CPin.default = CPin;
